module.exports = __webpack_public_path__ + "media/images/ic-number-profile-4e1cc694d36d08ce6cfd50bd5bd5d068.svg";